import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";
import { Toast } from "shared";
import { TOAST_TYPES_ENUM } from "enums";
import { queryClient } from "App";
import { CompanyUpdateClientType } from "types/CompanyTypes";

export const useUpdateCompanyClient = (
  options?: UseMutationOptions<any, Error, CompanyUpdateClientType>
) => {
  return useMutation({
    ...options,
    mutationKey: ["updateCompany/client"],
    mutationFn: async (data) => {
      const formData = new FormData();
      formData.append("shareId", data.shareId);
      formData.append("companyId", data.companyId);
      formData.append("name", data.name);
      formData.append("industryUuid", data.industryUuid);
      // formData.append("sharesCount", `${data.sharesCount}`);
      formData.append("publicationDate", `${data.publicationDate}`);
      
      if (data.sharesValue) {
        formData.append("sharesValue", `${data.sharesValue || null}`);
      }
      // formData.append("currencyUuid", data.currencyUuid);
      formData.append("type", data.type);
      formData.append(
        "isHistoryAccepted",
        `${!!data.isHistoryAccepted ? 1 : 0}`
      );
      if (data.pricePerShare) {
        formData.append("pricePerShare", `${data.pricePerShare}`);
      }
      formData.append("description", data.additionalInfo ?? "");
      if (data.invoice) {
        formData.append("invoice", data.invoice);
      }
      formData.append("nip", data.nip != null && data.nip !== "" ? data.nip : "null");
      if (data.depositoryType) {
        formData.append("depositoryType", data.depositoryType);
        if (data.depositoryId != null) {
          formData.append("depositoryId", `${data.depositoryId}`);
        }
        if (data.depositoryId === "other" && data.depositoryOtherName) {
          formData.append("depositoryOtherName", data.depositoryOtherName);
        }
        if (data.depositoryAccountNumber) {
          formData.append("depositoryAccountNumber", data.depositoryAccountNumber);
        }
      } else {
        formData.append("depositoryType", "null");
        formData.append("depositoryId", "");
        formData.append("depositoryAccountNumber", "");
      }

      return axiosInstance
        .put("/companies/client", formData)
        .then((res) => res.data);
    },
    onMutate: (variables) => {
      Toast({
        message: "Trwa dodawanie spółki...",
        type: TOAST_TYPES_ENUM.LOADING,
        id: "store-company",
      });
      if (options && options.onMutate) {
        // @ts-ignore
        return options.onMutate(variables);
      }
    },
    onSuccess: (data, variables, context) => {
      Toast({
        message: "Spółka dodana pomyślnie.",
        type: TOAST_TYPES_ENUM.SUCCESS,
        id: "store-company",
      });
      queryClient.invalidateQueries({ queryKey: ["companies/my"] });
      queryClient.invalidateQueries({ queryKey: ["shares/company"] });
      queryClient.invalidateQueries({ queryKey: ["transactions"] });
      queryClient.invalidateQueries({ queryKey: ["investments/grouped"] });
      if (options && options.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error, variables, context) => {
      Toast({
        message: "Błąd podczas dodawania spółki.",
        type: TOAST_TYPES_ENUM.ERROR,
        id: "store-company",
      });
      if (options && options.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};

export default useUpdateCompanyClient;
